import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import Grid from '@/global/components/ui/Grid'
import { estadosV2, getCidadesByUf } from '@acme/common'
import axios from 'axios'
import {
    FormField,
    FormFieldAutocomplete,
    FormFieldSelect,
} from 'global/components/Form'
import { ChangeEvent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ViaCepApi } from 'types'

export function DadosEndereco() {
    const [cidades, setCidades] = useState<
        Array<{ value: string; label: string }>
    >([])

    const { watch, setValue, getValues } = useFormContext()

    const uf = watch('uf'),
        ibge = watch('Cidade.ibge')

    function handleChangeCep(event: ChangeEvent<HTMLInputElement>) {
        const cep = event.target.value.replace(/\D/g, '')
        if (cep.length === 8) {
            axios
                .get<ViaCepApi>(`https://viacep.com.br/ws/${cep}/json/`)
                .then(
                    async ({
                        data: { logradouro: endereco, bairro, ibge, uf },
                    }) => {
                        setValue('uf', uf)
                        if (!getValues('endereco'))
                            setValue('endereco', endereco)
                        if (!getValues('bairro')) setValue('bairro', bairro)
                        await updateCidadesByUf(uf)
                        setValue('Cidade.ibge', Number(ibge))
                    },
                )
        }
    }

    async function updateCidadesByUf(uf: string) {
        if (!uf) return
        const cidades = await getCidadesByUf(uf)
        setCidades(
            cidades.map(c => ({
                value: String(c.id),
                label: c.nome,
            })),
        )
        if (
            ibge &&
            !cidades.find(cidade => Number(cidade.id) === Number(ibge))
        ) {
            setValue('Cidade.ibge', null)
        }
    }

    useEffect(() => {
        updateCidadesByUf(uf)
    }, [uf])

    return (
        <section id="endereco">
            <HorizontalDivider className="my-4 select-none">
                Endereço
            </HorizontalDivider>
            <Grid container columns={24}>
                <Grid item xs={12} sm={6}>
                    <FormField
                        name="cep"
                        label="CEP"
                        required
                        onChange={handleChangeCep}
                        options={{
                            blocks: [5, 3],
                            delimiter: '-',
                            numericOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormFieldSelect
                        name="uf"
                        label="UF"
                        required
                        options={estadosV2.map(({ sigla }) => ({
                            value: sigla,
                            label: sigla,
                        }))}
                    />
                </Grid>
                <Grid item xs={12} sm={14}>
                    <FormFieldAutocomplete
                        name="Cidade.ibge"
                        label="Cidade de trabalho"
                        placeholder="Selecione a cidade"
                        required
                        options={cidades}
                        // O campo guarda o código IBGE; a opção é {value,label}.
                        paraCampo={valor =>
                            valor
                                ? (cidades.find(
                                      cidade => cidade.value === String(valor),
                                  ) ?? null)
                                : null
                        }
                        paraFormulario={cidade => cidade?.value ?? null}
                        isOptionEqualToValue={(opcao, valorAtual) =>
                            opcao.value === valorAtual?.value
                        }
                        noOptionsText={
                            uf
                                ? 'Nenhuma cidade encontrada'
                                : 'Selecione a UF primeiro'
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={8}>
                    <FormField name="bairro" label="Bairro" required />
                </Grid>
                <Grid item xs={16} sm={11}>
                    <FormField name="endereco" label="Endereço" required />
                </Grid>
                <Grid item xs={8} sm={5}>
                    <FormField name="numero" label="Número" required />
                </Grid>
            </Grid>
        </section>
    )
}
